import { render, staticRenderFns } from "./IngredientRevisionHistory.vue?vue&type=template&id=749d1a10&scoped=true&"
import script from "./IngredientRevisionHistory.vue?vue&type=script&lang=ts&"
export * from "./IngredientRevisionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./IngredientRevisionHistory.vue?vue&type=style&index=0&id=749d1a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d1a10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
